import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=93e585ce&scoped=true&"
import script from "./DownloadButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadButton.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=93e585ce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e585ce",
  null
  
)

export default component.exports